import React from 'react'
import PropTypes from 'prop-types'
import { browserHistory } from 'react-router'
import Helmet from 'react-helmet'
import AppBar from 'material-ui/AppBar'
import IconButton from 'material-ui/IconButton'
import NavigationArrowBack from 'material-ui/svg-icons/navigation/arrow-back'
import Login from '../../Login/Container'

export default function Page(props) {
	return (
		<div className={`page ${props.className}`}>
			<Helmet
				title={props.pageTitle || props.title}
				meta={[
					{ name: 'description', content: props.description },
				]}
			/>
			<AppBar
				className="header"
				iconElementLeft={<IconButton><NavigationArrowBack /></IconButton>}
				iconElementRight={<Login />}
				iconStyleRight={{ marginTop: '14px' }}
				onLeftIconButtonTouchTap={() => browserHistory.goBack()}
				showMenuIconButton={!!props.showBack}
				title={props.title}
				titleStyle={props.titleStyle}
			/>
			{props.masthead}
			<div className="content">
				{props.children}
			</div>
		</div>
	)
}

Page.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	description: PropTypes.string,
	masthead: PropTypes.node,
	pageTitle: PropTypes.string,
	showBack: PropTypes.bool,
	title: PropTypes.string,
	titleStyle: PropTypes.object, // eslint-disable-line
}

Page.defaultProps = {
	children: null,
	className: '',
	description: null,
	showBack: false,
	title: null,
	titleStyle: null,
}



// WEBPACK FOOTER //
// ./src/components/common/page/Page.jsx